function CustomBarChart({
    title,
    value,
    maxValue = 100,
    width = 120,
    height = 180,
    barColor = '#38bdf8',
    bgColor = '#1f2933',
    onBarClick, // ✅ new
}) {
    const hasTitle = Boolean(title && title.trim());

    const bottomPadding = hasTitle ? 22 : 8;
    const topPadding = 14;

    const safeValue = Math.min(Math.max(value, 0), maxValue);

    const barHeight =
        (safeValue / maxValue) * (height - topPadding - bottomPadding);

    const barWidth = width * 0.35;
    const x = (width - barWidth) / 2;
    const y = height - barHeight - bottomPadding;

    return (
        <svg
            width={width}
            height={height}
            className="block overflow-visible"
        >
            {/* Background */}
            <rect
                width={width}
                height={height}
                rx="10"
                fill={bgColor}
            />

            {/* Bar (hover-safe) */}
            <rect
                x={x}
                y={y}
                width={barWidth}
                height={barHeight}
                rx="6"
                fill={barColor}
                style={{
                    cursor: 'pointer',
                    transformOrigin: `${x + barWidth / 2}px ${y + barHeight}px`,
                    transition: 'transform 0.25s ease, filter 0.25s ease',
                }}
                onMouseEnter={(e) => {
                    e.currentTarget.style.transform = 'scaleY(1.07) scaleX(1.08)';
                    e.currentTarget.style.filter = 'brightness(1.15)';
                }}
                onMouseLeave={(e) => {
                    e.currentTarget.style.transform = 'scale(1)';
                    e.currentTarget.style.filter = 'none';
                }}
                onClick={onBarClick}
            />

            {/* Value */}
            <text
                x={width / 2}
                y={y - 6}
                textAnchor="middle"
                fontSize="11"
                fill="#e5e7eb"
                fontWeight="600"
                pointerEvents="none"
            >
                {safeValue}%
            </text>

            {/* Title */}
            {hasTitle && (
                <text
                    x={width / 2}
                    y={height - 6}
                    textAnchor="middle"
                    fontSize="12"
                    fill="#e5e7eb"
                    pointerEvents="none"
                >
                    {title}
                </text>
            )}
        </svg>
    );
}

export default CustomBarChart;